var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVibSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0244 3.01622C26.9749 3.01622 25.5961 3.71371 23.9416 5.51419L20.0649 9.79643L16.1882 5.49797C14.3877 3.69749 13.1387 3 10.1055 3H5.53125C5.53125 3 12.5872 11.8565 13.5604 12.8297C15.0852 14.4842 16.0584 15.3114 18.1347 15.3114H21.8654C23.9416 15.3114 25.0446 14.4842 26.5694 12.8297C27.5264 11.8565 34.5986 3 34.5986 3H30.0244V3.01622Z",
    fill: "#FCB813"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5426 14.5003C25.3366 14.9221 24.0877 15.4574 22.9684 17.2741L21.9952 18.7988L21.1679 20.4695C20.0649 22.27 20.1947 23.6488 21.022 25.871C21.4437 27.12 25.4502 37.6471 25.4502 37.6471L27.8022 33.7704C29.3269 31.1427 29.3269 29.6179 28.6294 27.266L26.9749 21.7347L32.5224 20.4857C35.0041 19.9342 36.2531 19.0908 37.7778 16.4793L40.0001 12.4565C40.0001 12.4565 28.9214 14.257 27.5426 14.5328V14.5003Z",
    fill: "#F37920"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9619 20.4534L17.9886 18.7827L17.1614 17.2579C16.0584 15.4574 14.8094 14.9059 12.5872 14.4842C11.2084 14.2084 0 12.408 0 12.408L2.35198 16.4307C3.8605 19.0584 5.10948 19.8857 7.47769 20.4372L13.1387 21.6861L11.3382 27.2174C10.6569 29.5694 10.7705 31.0941 12.2952 33.7218L14.5174 37.5986C14.5174 37.5986 18.6699 27.0714 19.0754 25.8224C19.7567 23.6002 20.0487 22.2214 18.9457 20.4209L18.9619 20.4534Z",
    fill: "#F6921E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibSquare);
export default __webpack_public_path__ + "static/media/vib-square.a32f130be85efeff48c62dfa303c61ae.svg";
export { ForwardRef as ReactComponent };